export class WebhookV1StandardPayloadClassificationJobRejected {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadClassificationJobRejectedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadClassificationJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobRejected.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadClassificationJobRejectedTypeEnum;
(function (WebhookV1StandardPayloadClassificationJobRejectedTypeEnum) {
    WebhookV1StandardPayloadClassificationJobRejectedTypeEnum["ClassificationJobRejected"] = "CLASSIFICATION_JOB_REJECTED";
})(WebhookV1StandardPayloadClassificationJobRejectedTypeEnum || (WebhookV1StandardPayloadClassificationJobRejectedTypeEnum = {}));
